import React, { useEffect, useState } from "react";
import Select from "react-select";
import { isEmpty, startCase } from "lodash";
import { FaEye } from "react-icons/fa";

import { apiGet } from "../Utils/apiFetch";
import { apiPath } from "../Utils/apiPath";
import {
  betCheckData,
  betCheckDataInner,
  betCheckObj,
  DownlineHeader,
  formatDate,
  toFixedWithoutRounding,
} from "../Utils/Constant";
import AuthContext from "../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import ParlayBets from "./ParlayBets";
import ParlayModal from "./RiskManagement/ParlayModal";
import Pagination from "../components/Pagination";

const style = { padding: "8px" };
const styleBody = { padding: "8px 7px" };

const LIMIT_OPTIONS = [10, 50, 100, 500, 1000];
const REFRESH_INTERVAL_MS = 15 * 1000;
const CAN_VIEW_LEGS = ["owner", "admin", "sub_owner", "super_admin"];

const marketOptions = [
  { value: "all", label: "Select Market" },
  { value: "football", label: "Football" },
  { value: "cricket", label: "Cricket" },
  { value: "tennis", label: "Tennis" },
];

const currencyOptions = [{ value: "pbu", label: "USD" }];

const userOptions = [
  { value: "1", label: "User 1" },
  { value: "2", label: "User 2" },
  { value: "3", label: "User 3" },
];

const eventOptions = [
  { value: "1", label: "Event 1" },
  { value: "2", label: "Event 2" },
  { value: "3", label: "Event 3" },
];

const DEFAULT_FILTER = {
  type: "all",
  pageType: "live",
  page: 1,
  limit: 50,
};

const DEFAULT_PAGINATION = {
  page: 1,
  limit: 50,
  totalRecords: 0,
  totalPages: 1,
  hasNextPage: false,
  hasPreviousPage: false,
};

// drop empty values so the API only gets filters that are actually set
const buildParams = (f) =>
  Object.fromEntries(
    Object.entries(f).filter(
      ([, v]) => v !== "" && v !== null && v !== undefined,
    ),
  );
const BetListLive = () => {
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);

  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState(DEFAULT_PAGINATION);
  const [filter, setFilter] = useState(DEFAULT_FILTER);
  const [debouncedFilter, setDebouncedFilter] = useState(DEFAULT_FILTER);
  const [refreshKey, setRefreshKey] = useState(0);
  const [show, setShow] = useState({});

  const getData = async (activeFilter, config = {}) => {
    const { status, data: response } = await apiGet(
      apiPath.newLiveBet,
      buildParams(activeFilter),
      config,
    );
    if (status === 200 && response.success) {
      setData(response.data || []);
      setPagination(response.pagination || DEFAULT_PAGINATION);
    }
  };

  // debounce so typing in search / stake / IP doesn't fire a request per keystroke
  useEffect(() => {
    const t = setTimeout(() => setDebouncedFilter(filter), 500);
    return () => clearTimeout(t);
  }, [filter]);

  // fetch whenever ANY filter (type, page, limit, user, event, market, ...) changes
  useEffect(() => {
    getData(debouncedFilter);
  }, [debouncedFilter, refreshKey]);

  // auto-refresh with the current filters, without the global loader
  useEffect(() => {
    const id = setInterval(() => {
      getData(debouncedFilter, { skipLoader: true });
    }, REFRESH_INTERVAL_MS);
    return () => clearInterval(id);
  }, [debouncedFilter]);

  const updateFilter = (patch) =>
    setFilter((prev) => ({ ...prev, page: 1, ...patch }));

  const handleLimitChange = (e) =>
    updateFilter({ limit: Number(e.target.value) });
  const handleSearchChange = (e) => updateFilter({ search: e.target.value });
  const handleIpChange = (e) => updateFilter({ ipAddress: e.target.value });
  const handleStakeChange = (e) => updateFilter({ stake: e.target.value });
  const handleUserChange = (s) => updateFilter({ userId: s?.value || "" });
  const handleEventChange = (s) => updateFilter({ eventId: s?.value || "" });
  const handleMarketChange = (s) => updateFilter({ market: s?.value || "" });
  const handleCurrencyChange = (s) =>
    updateFilter({ currency: s?.value || "" });
  const handleTypeChange = (newType) => updateFilter({ type: newType });

  const handlePageChange = (page) => {
    setFilter((prev) => ({ ...prev, page }));
    // setDebouncedFilter((prev) => ({ ...prev, page }));
  };
  const handleRefresh = () => setRefreshKey((k) => k + 1);

  const handleShowDefault = () => {
    setFilter(DEFAULT_FILTER);
    setDebouncedFilter(DEFAULT_FILTER); // apply immediately, no debounce wait
    setRefreshKey((k) => k + 1); // forces a fetch even if filters were already default
  };

  const rows = Array.isArray(data) ? data : [];

  // after the pagination state
  const paginationData = {
    ...pagination,
    totalDocs: pagination.totalRecords,
    hasPrevPage: pagination.hasPreviousPage, // mongoose-paginate style name
  };
  return (
    <app-bet-list-live className="ng-star-inserted">
      <div className="full-wrap">
        <div className="over-wrap">
          <div className="total_all">
            <h2>Live Bet</h2>
            <span className="spacer" />
            <span style={{ marginLeft: "auto", whiteSpace: "nowrap" }}>
              {" "}
              Total Records: <strong> {data?.length || 0}</strong>
            </span>{" "}
            &nbsp; &nbsp;
          </div>

          <div id="limitCondition" className="function-wrap">
            <ul className="input-list diaplayflex">
              <li id="eventRadioBtnList">
                {/* <input
                  type="radio"
                  name="eventType"
                  id="All"
                  value="all"
                  checked={filter?.type === "all"}
                  onChange={(e) => handleTypeChange(e.target.value)}
                /> */}
                {/* <label htmlFor="All">All</label> */}
                {eventTypes.map(({ label, value }) => (
                  <React.Fragment key={value}>
                    <input
                      type="radio"
                      name="eventType"
                      id={`type-${value}`}
                      value={value}
                      checked={filter?.type == value}
                      onChange={(e) => handleTypeChange(e.target.value)}
                    />
                    <label htmlFor={`type-${value}`}>{label}</label>
                  </React.Fragment>
                ))}
                {/* {betCheckData.map(({ label, value }) => (
                  <React.Fragment key={value}>
                    <input
                      type="radio"
                      name="eventType"
                      id={`type-${value}`}
                      value={value}
                      checked={filter?.type == value}
                      onChange={(e) => handleTypeChange(e.target.value)}
                    />
                    <label htmlFor={`type-${value}`}>{label}</label>
                  </React.Fragment>
                ))} */}

                {/* {filter.type != 3 &&
                  betCheckDataInner.map(({ label, value }) => (
                    <React.Fragment key={value}>
                      <input
                        type="radio"
                        name="eventBetType"
                        id={`betType-${value}`}
                        value={value}
                        checked={filter?.type == value}
                        onChange={(e) => handleBetTypeChange(e.target.value)}
                      />
                      <label htmlFor={`betType-${value}`}>{label}</label>
                    </React.Fragment>
                  ))} */}
              </li>
              <span className="spacer" />
            </ul>

            <ul className="input-list contentclass wrapInput">
              <li>
                <input
                  type="text"
                  appinputrestriction="noSpecialChars3"
                  className="widthfull"
                  placeholder="Search Here"
                  value={filter?.search}
                  onChange={handleSearchChange}
                />
              </li>

              <div className="diaplayflex1 divblock">
                <li className="widthfull ng-star-inserted">
                  <div className="ng-tns-c130-1 ng-star-inserted">
                    <Select
                      options={userOptions}
                      placeholder="Select User"
                      isSearchable={false}
                      isClearable={true}
                      value={
                        userOptions.find((o) => o.value === filter.userId) ||
                        null
                      }
                      onChange={handleUserChange}
                      className="ng-tns-c130-1 p-dropdown p-component p-dropdown-clearable"
                      classNamePrefix="p-dropdown"
                    />
                  </div>
                </li>

                <li></li>

                <li className="widthfull">
                  <div className="widthfull ng-select ng-select-single ng-select-searchable ng-select-clearable">
                    <Select
                      options={eventOptions}
                      placeholder="Select Event"
                      isSearchable={true}
                      isClearable={true}
                      value={
                        eventOptions.find((o) => o.value === filter.eventId) ||
                        null
                      }
                      onChange={handleEventChange}
                      className="widthfull"
                      classNamePrefix="ng"
                    />
                  </div>
                </li>
              </div>

              <div className="diaplayflex1 divblock">
                <li className="widthfull">
                  <div className="widthfull ng-select ng-select-single ng-select-searchable ng-select-clearable">
                    <Select
                      options={marketOptions}
                      placeholder="Select Market"
                      isSearchable={true}
                      isClearable={true}
                      value={
                        marketOptions.find((o) => o.value === filter.market) ||
                        null
                      }
                      onChange={handleMarketChange}
                      className="widthfull"
                      classNamePrefix="ng"
                    />
                  </div>
                </li>

                <li className="widthfull">
                  <div className="widthfull ng-select ng-select-single ng-select-searchable ng-select-clearable">
                    <Select
                      options={currencyOptions}
                      placeholder="Select Currency"
                      isSearchable={true}
                      isClearable={true}
                      value={
                        currencyOptions.find(
                          (o) => o.value === filter.currency,
                        ) || null
                      }
                      onChange={handleCurrencyChange}
                      className="widthfull"
                      classNamePrefix="ng"
                    />
                  </div>
                </li>
              </div>

              <div className="diaplayflex divblock">
                <li className="widthfull">
                  <label>Last:</label>
                  <select
                    name="limit"
                    id="limit"
                    className="widthfull"
                    value={filter?.limit}
                    onChange={handleLimitChange}
                  >
                    {LIMIT_OPTIONS.map((val) => (
                      <option key={val} value={val}>
                        {`${val} Txn`}
                      </option>
                    ))}
                  </select>
                </li>
                <li className="widthfull">
                  <label>Stake</label>
                  <input
                    type="number"
                    name="Volume Check"
                    className="widthfull"
                    style={{ width: "100%" }}
                    placeholder="Volume"
                    value={filter?.stake}
                    onChange={handleStakeChange}
                  />
                </li>
                <li className="widthfull">
                  <input
                    type="text"
                    name="ipAddress"
                    placeholder="Search IP"
                    className="widthfull"
                    style={{ width: "100%" }}
                    value={filter?.ipAddress}
                    onChange={handleIpChange}
                  />
                </li>
                <li>
                  <a
                    id="betListLiveRefresh"
                    className="btn-send"
                    onClick={handleRefresh}
                  >
                    Refresh
                  </a>
                </li>
                <li className="widthfull">
                  <a
                    id="getPLLive"
                    className="btn-send"
                    onClick={handleShowDefault}
                  >
                    Show Default
                  </a>
                </li>
                <li style={{ marginLeft: "auto", whiteSpace: "nowrap" }} />
              </div>
            </ul>
          </div>

          <div className="table-responsive data-table">
            {" "}
            <div
              style={{
                backgroundColor: "#3b5160",
                borderBottom: "1px solid #7e97a7",
                color: "#fff",
                lineHeight: "2",
                fontWeight: "700",
                padding: "0 10px",
                width: "100%",
              }}
              id="matchedTitle"
            >
              Matched
            </div>
            <table
              id="matchTable"
              className="table-s"
              style={{ display: "table" }}
            >
              <tbody>
                {filter?.type == "parlay" ? (
                  <tr _ngcontent-serverapp-c84>
                    {DownlineHeader(user?.userType)?.map((res) => {
                      return (
                        <th
                          _ngcontent-serverapp-c84
                          width="4%"
                          data-order="asc"
                          data-name="playerId"
                          className="align-L sort_asc ng-star-inserted"
                        >
                          {" "}
                          {res?.value} ID{" "}
                        </th>
                      );
                    })}

                    <th
                      _ngcontent-serverapp-c84
                      width="3%"
                      data-order="asc"
                      data-name="playerId"
                      className="align-L sort_asc"
                    >
                      PL ID{" "}
                    </th>
                    <th
                      _ngcontent-serverapp-c84
                      width="5%"
                      data-order="asc"
                      data-name="consolidateId"
                      className="align-L sort_asc"
                    >
                      {" "}
                      Bet ID
                    </th>
                    <th
                      _ngcontent-serverapp-c84
                      id="betTime"
                      width="6%"
                      data-order="asc"
                      data-name="betTime"
                      className="align-L sort_asc"
                    >
                      Bet Placed{" "}
                    </th>

                    <th
                      _ngcontent-serverapp-c84
                     width="10%"
                      data-order="asc"
                      data-name="eventName"
                      className="align-L sort_asc"
                    >
                      Event
                    </th>
                    <th
                      _ngcontent-serverapp-c84
                       width="5%"
                      data-order="asc"
                      data-name="selName"
                      className="align-L sort_asc"
                    >
                      Market
                    </th>
                    <th
                      _ngcontent-serverapp-c84
                      width="2%"
                      data-order="asc"
                      data-name="betType"
                      className="align-L sort_asc"
                    >
                      {" "}
                      Type{" "}
                    </th>
                    <th
                      _ngcontent-serverapp-c84
                        width="2%"
                      data-order="asc"
                      data-name="odds"
                      className="sort_asc"
                    >
                      Odds
                    </th>
                    <th
                      _ngcontent-serverapp-c84
                      width="2%"
                      data-order="asc"
                      data-name="stake"
                      className="sort_asc"
                    >
                      Stake{" "}
                    </th>
                    <th
                      _ngcontent-serverapp-c84
                      width="5%"
                      name="profitOrLossTh"
                      data-order="asc"
                      data-name="PL"
                      className="sort_asc"
                    >
                      Pot Liability
                    </th>
                    <th
                      _ngcontent-serverapp-c84
                      width="5%"
                      name="status"
                      data-order="asc"
                      data-name="status"
                      className="sort_asc"
                    >
                      {" "}
                      Pot Profit
                    </th>
                    <th
                      _ngcontent-serverapp-c84
                      width="5%"
                      name="status"
                      data-order="asc"
                      data-name="status"
                      className="sort_asc"
                    >
                      {" "}
                      Live Bet
                    </th>
                    <th
                      _ngcontent-serverapp-c84
                      width="7%"
                      data-order="asc"
                      data-name="ipAddress"
                      className="align-L sort_asc"
                    >
                      {" "}
                      IP Address{" "}
                    </th>
                  </tr>
                ) : (
                  <tr>
                    {DownlineHeader(user?.userType)?.map((res) => {
                      return (
                        <th style={style} width="5%" className="align-L">
                          {" "}
                          {res?.value} ID{" "}
                        </th>
                      );
                    })}
                    <th style={style} width="5%" className="align-L">
                      PL ID
                    </th>
                    <th style={style} width="6%" className="align-L">
                      Bet ID
                    </th>
                    <th
                      style={style}
                      id="betTime"
                      width="6%"
                      className="align-L"
                    >
                      Bet Placed
                    </th>
                    <th style={style} width="10%" className="align-L">
                      Event
                    </th>
                    <th style={style} width="7%" className="align-L">
                      Market
                    </th>
                    <th style={style} width="4%" className="align-C">
                      Type
                    </th>
                    <th style={style} width="4%" className="align-R">
                      Odds
                    </th>
                    <th style={style} width="5%">
                      Stake
                    </th>
                    <th style={style} width="5%" className="">
                      Pot Liability
                    </th>
                    <th style={style} width="5%" className="">
                      Pot Profit
                    </th>
                    <th style={style} width="7%" className="align-L">
                      IP Address
                    </th>
                  </tr>
                )}
                {rows.length > 0 ? (
                  filter?.type == "parlay" ? (
                    <ParlayBets
                      filter={filter}
                      data={rows}
                      show={show}
                      setShow={setShow}
                      user={user}
                    />
                  ) : (
                    rows.map((item) => {
                      const isBetfair = item?.betFaireType === "betfair";

                      return (
                        <tr
                          id="matchRowTemplate"
                          key={item?._id || item?.matchBetId}
                          className="ng-star-inserted"
                        >
                          {DownlineHeader(user?.userType)?.map((res) => {
                            return (
                              <td style={styleBody} className="align-L">
                                {item[res?.key]?.username || "N/A"}
                              </td>
                            );
                          })}

                          <td style={styleBody} className="align-L">
                            {item?.clientName || "-"}
                          </td>
                          <td
                            style={styleBody}
                            _ngcontent-serverapp-c119
                            className="align-L"
                          >
                            <a href="#" _ngcontent-serverapp-c119 id="betID">
                              {item?.matchBetId ||
                                item?.casinoBetId ||
                                item?.sessionBetId}
                            </a>
                          </td>
                          <td style={styleBody} className="align-L">
                            <span id="betPlaced" className="small-date">
                              {formatDate(
                                item?.timeInserted ||
                                  item?.createdAt ||
                                  item?.betPlaced,
                              )}
                            </span>
                          </td>
                          <td
                            style={styleBody}
                            _ngcontent-serverapp-c119
                            id="matchTitle"
                            className="align-L"
                            title="cricket > Tiruppur Tamizhans v Salem Spartans > 6 Over SS"
                          >
                            {item?.sportName ||
                              betCheckObj[item?.eventType] ||
                              item?.platform}
                            <img
                              _ngcontent-serverapp-c119
                              src="/assets/images/transparent.gif"
                              className="fromto"
                            />
                            {item?.casinoName || item?.matchName}
                            <img
                              _ngcontent-serverapp-c119
                              src="/assets/images/transparent.gif"
                              className="fromto"
                            />
                            <strong _ngcontent-serverapp-c119>
                              {item?.exchangeType == "session"
                                ? "Fancy Bet"
                                : item?.exchangeType == "bookmaker"
                                  ? "Bookmaker"
                                  : item?.market ||
                                    item?.fancyName ||
                                    item?.gameCode}{" "}
                            </strong>
                          </td>
                          <td
                            style={styleBody}
                            id="matchSelection"
                            className="align-L"
                          >
                            {item?.exchangeType == "session"
                              ? item?.fancyName
                              : item?.runnerName ||
                                item?.selectionName ||
                                item?.teamName ||
                                item?.fancyName ||
                                item?.platform}
                          </td>
                          <td
                            style={styleBody}
                            _ngcontent-serverapp-c119
                            className="align-C"
                          >
                            <span
                              _ngcontent-serverapp-c119
                              id="matchType"
                              className={
                                item?.betType === "back" || item?.type === "Yes"
                                  ? "yes"
                                  : "no"
                              }
                            >
                              {startCase(
                                item?.betType || item?.type || item?.gameCode,
                              )}{" "}
                            </span>
                          </td>
                          <td
                            style={styleBody}
                            _ngcontent-serverapp-c119
                            id="matchOddsReq"
                          >
                            {item?.exchangeType == "session"
                              ? item?.betRun + ":" + item?.bhav
                              : toFixedWithoutRounding(item?.bhav) || "-"}{" "}
                          </td>
                          <td style={styleBody} id="matchStake">
                            {item?.amount || item?.stake || 0}{" "}
                            <strong>(USD)</strong>
                          </td>
                          <td
                            style={styleBody}
                            id="liability"
                            className="loss-text-dark"
                          >
                            {item?.loseAmount ?? "-"}
                          </td>
                          <td style={styleBody} className="profit-text-dark">
                            {item?.profitAmount ?? "-"}{" "}
                            <span id="pol" className="small-date"></span>
                          </td>
                          <td style={styleBody} id="ip" className="align-L">
                            {(item?.ipAddress &&
                              item.ipAddress.replace("::ffff:", "")) ||
                              "-"}
                          </td>
                        </tr>
                      );
                    })
                  )
                ) : (
                  <tr>
                    <td colSpan={13}>
                      <span>You have no bets in this time period.</span>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {rows.length > 0 && pagination.totalRecords > 0 && (
            <Pagination
              pagination={paginationData}
              onPageChange={handlePageChange}
            />
          )}
        </div>
      </div>
      <ParlayModal isOpen={show?.status} data={show?.data} onClose={setShow} />
    </app-bet-list-live>
  );
};

export default BetListLive;

const eventTypes = [
  { value: "all", label: "All" },
  { value: "soccer", label: "Soccer" },
  { value: "tennis", label: "Tennis" },
  { value: "cricket", label: "Cricket" },
  { value: "sportbook", label: "Premium" },
  { value: "bookmaker", label: "Bookmaker" },
  { value: "fancy", label: "Fancy" },
  { value: "parlay", label: "parlay" },
  // { value: "Live Casino", label: "Live Casino" },
  { value: "horseracing", label: "Horse Racing" },
  { value: "greyhound", label: "Greyhound Racing" },
  { value: "kabaddi", label: "Kabaddi" },
  { value: "election", label: "Election" },
];
